import InputWithAutocomplete from './inputWithAutocomplete';

export default InputWithAutocomplete;
